<div class="header-container">
  <div class="accent-main"></div>
  <div class="page-name"  i18n="@@pageTitleProducts">OUR PRODUCTS</div>
</div>